import request from '@/utils/request';


export async function pickdeviceconfig(payload) {
  return request(`/iwms-wms/wms/pickdeviceconfig`, {
    method: 'POST',
    body: payload,
  });
}

export async function deleteConfig(payload) {
  return request(`/iwms-wms/wms/pickdeviceconfig/delete?uuid=${payload.uuid}`, {
    method: 'POST',
  });
}

export async function modify(payload) {
  return request(`/iwms-wms/wms/pickdeviceconfig/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function page(payload) {
  return request(`/iwms-wms/wms/pickdeviceconfig/page`, {
    method: 'POST',
    body: payload,
  });
}
